import {combineReducers} from 'redux';
import posts from './posts';
import homePost from './homePost';
import auth from './auth';
import review from './reviews';

export default combineReducers({posts,homePost,auth,review});